export const LEGEND_MAX_ICON_COLOR = 'gray-lightest-3';
export const SINGLE_VALUE_PROGRESS_COLOR = 'blue';
export const PROGRESS_COLORS = [
  'blue',
  'blue-light',
  'blue-lightest',
  'green-lightest',
  'gray-darker',
  'gray-lightest-3',
  'green',
  'slate',
  'red',
  'yellow',
  'orange',
  'purple',
  'pink',
];
